"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Months = exports.Days = void 0;
var Days = [{
  label: 'Sunday',
  key: 0
}, {
  label: 'Monday',
  key: 1
}, {
  label: 'Tuesday',
  key: 2
}, {
  label: 'Wednesday',
  key: 3
}, {
  label: 'Thursday',
  key: 4
}, {
  label: 'Friday',
  key: 5
}, {
  label: 'Saturday',
  key: 6
}];
exports.Days = Days;
var Months = [{
  label: 'January',
  shortName: 'Jan',
  key: 0
}, {
  label: 'February',
  shortName: 'Feb',
  key: 1
}, {
  label: 'March',
  shortName: 'Mar',
  key: 2
}, {
  label: 'April',
  shortName: 'Apr',
  key: 3
}, {
  label: 'May',
  shortName: 'May',
  key: 4
}, {
  label: 'June',
  shortName: 'Jun',
  key: 5
}, {
  label: 'July',
  shortName: 'Jul',
  key: 6
}, {
  label: 'August',
  shortName: 'Aug',
  key: 7
}, {
  label: 'September',
  shortName: 'Sep',
  key: 8
}, {
  label: 'October',
  shortName: 'Oct',
  key: 9
}, {
  label: 'November',
  shortName: 'Nov',
  key: 10
}, {
  label: 'December',
  shortName: 'Dec',
  key: 11
}];
exports.Months = Months;